const getCityStateNameFromLocation = ({
  city,
  state
}: {
  city?: string | null;
  state?: string | null;
}) => {
  if (!city) {
    return '';
  }

  return `${city}${state ? `/${state}` : ''}`;
};
export default getCityStateNameFromLocation;
